import { ui } from "../app/store.js";
import { esc } from "../domain/format.js";

let scriptPromise;

export function captchaSlot() {
  return ui.turnstileSiteKey
    ? `<div class="captcha-slot" data-sitekey="${esc(ui.turnstileSiteKey)}" aria-label="Security check"></div>`
    : "";
}

function loadScript() {
  if (globalThis.turnstile) return Promise.resolve();
  if (!scriptPromise)
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      script.async = true;
      script.onload = resolve;
      script.onerror = () => reject(new Error("Security check could not load."));
      document.head.append(script);
    });
  return scriptPromise;
}

export async function mountCaptcha() {
  const slots = [...document.querySelectorAll(".captcha-slot")];
  if (!slots.length) return;
  try {
    await loadScript();
    for (const slot of slots) {
      if (!slot.isConnected || slot.dataset.widgetId !== undefined) continue;
      const id = globalThis.turnstile.render(slot, {
        sitekey: slot.dataset.sitekey,
        action: "milltech_auth",
        theme: "light",
        size: "flexible",
        callback: (token) => (slot.dataset.token = token),
        "expired-callback": () => delete slot.dataset.token,
        "error-callback": () => delete slot.dataset.token,
      });
      slot.dataset.widgetId = String(id);
    }
  } catch {
    for (const slot of slots)
      if (slot.isConnected) slot.textContent = "Security check could not load. Refresh and try again.";
  }
}

export function unmountCaptcha() {
  for (const slot of document.querySelectorAll(".captcha-slot")) {
    if (slot.dataset.widgetId !== undefined) {
      globalThis.turnstile?.remove(slot.dataset.widgetId);
      delete slot.dataset.widgetId;
    }
  }
}

export function captchaHeaders(container) {
  if (!ui.turnstileSiteKey) return {};
  const token = container?.querySelector(".captcha-slot")?.dataset.token;
  if (!token) throw new Error("Complete the security check and try again.");
  return { "x-captcha-response": token };
}

export function resetCaptcha(container) {
  const slot = container?.querySelector(".captcha-slot");
  if (!slot) return;
  delete slot.dataset.token;
  if (slot.dataset.widgetId !== undefined)
    globalThis.turnstile?.reset(slot.dataset.widgetId);
}
